import React from "react";
import { useSelector } from 'react-redux';
import MissionImg1 from "../../assest/Mission-1.png";
import MissionImg2 from "../../assest/Mission-2.png";
import MissionImg3 from "../../assest/Mission-3.png";
import MissionIcon from "../../assest/Mission-icon.png";
import VissionIcon from "../../assest/Vission-icon.png";

const Who = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      heading: "Who We Are",
      missionTitle: "Mission",
      missionText:
        "At Etihad Gharbia Contracting Company, our mission is to deliver reliable and high-quality contracting services, manpower solutions, and equipment rentals that meet the evolving needs of our clients. We are committed to safety, efficiency, and innovation, ensuring that every project we undertake exceeds expectations and builds long-term trust.",
      visionTitle: "Vision",
      visionText:
        "Our vision is to be the leading force in the construction and contracting industry across the Kingdom of Saudi Arabia, recognized for our integrity, professionalism, and excellence. We aim to empower national development by providing cutting-edge solutions in construction, logistics, and manpower with a strong focus on client satisfaction and sustainable growth.",
    },
    sa: {
      heading: "من نحن",
      missionTitle: "المهمة",
      missionText:
        "في شركة الاتحاد الغربية للمقاولات، مهمتنا هي تقديم خدمات مقاولات موثوقة وعالية الجودة، وحلول القوى العاملة، وتأجير المعدات التي تلبي الاحتياجات المتطورة لعملائنا. نحن ملتزمون بالسلامة والكفاءة والابتكار، مما يضمن أن كل مشروع نقوم به يتجاوز التوقعات ويبني الثقة طويلة الأمد.",
      visionTitle: "الرؤية",
      visionText:
        "رؤيتنا هي أن نكون القوة الرائدة في صناعة البناء والمقاولات في جميع أنحاء المملكة العربية السعودية، وأن نُعرف بنزاهتنا واحترافيتنا وتميزنا. نهدف إلى تمكين التنمية الوطنية من خلال تقديم حلول متطورة في البناء واللوجستيات والقوى العاملة مع التركيز القوي على رضا العملاء والنمو المستدام.",
    },
    fr: {
      heading: "Qui nous sommes",
      missionTitle: "Mission",
      missionText:
        "Chez Etihad Gharbia Contracting Company, notre mission est de fournir des services de contracting fiables et de haute qualité, des solutions de main-d'œuvre et des locations d'équipements qui répondent aux besoins évolutifs de nos clients. Nous nous engageons à assurer la sécurité, l'efficacité et l'innovation, garantissant que chaque projet que nous entreprenons dépasse les attentes et construit une confiance à long terme.",
      visionTitle: "Vision",
      visionText:
        "Notre vision est d'être la force principale dans l'industrie de la construction et du contracting à travers le Royaume d'Arabie saoudite, reconnue pour notre intégrité, notre professionnalisme et notre excellence. Nous visons à favoriser le développement national en fournissant des solutions de pointe dans la construction, la logistique et la main-d'œuvre avec un fort accent sur la satisfaction des clients et la croissance durable.",
    },
    de: {
      heading: "Wer wir sind",
      missionTitle: "Mission",
      missionText:
        "Bei der Etihad Gharbia Contracting Company ist es unsere Mission, zuverlässige und qualitativ hochwertige Contracting-Dienstleistungen, Arbeitskräftelösungen und Gerätevermietungen anzubieten, die den sich entwickelnden Bedürfnissen unserer Kunden entsprechen. Wir setzen uns für Sicherheit, Effizienz und Innovation ein, um sicherzustellen, dass jedes Projekt, das wir durchführen, die Erwartungen übertrifft und langfristiges Vertrauen aufbaut.",
      visionTitle: "Vision",
      visionText:
        "Unsere Vision ist es, die führende Kraft in der Bau- und Contracting-Branche im gesamten Königreich Saudi-Arabien zu sein, anerkannt für unsere Integrität, Professionalität und Exzellenz. Wir streben an, die nationale Entwicklung zu fördern, indem wir innovative Lösungen in den Bereichen Bau, Logistik und Arbeitskräfte mit einem starken Fokus auf Kundenzufriedenheit und nachhaltiges Wachstum bieten.",
    },
  };

  const t = translations[language] || translations.gb;

  return (
    <div className="container py-4 py-md-5">
      {/* Heading */}
      <h2 className="text-center fw-bold mb-4">
        {t.heading}
        <div className="d-flex justify-content-center">
          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#c8102e",
              marginTop: "8px",
            }}
          ></div>
          <div
            style={{
              width: "5px",
              height: "3px",
              backgroundColor: "#c8102e",
              margin: "8px 4px 0 4px",
            }}
          ></div>
          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#c8102e",
              marginTop: "8px",
            }}
          ></div>
        </div>
      </h2>

      <div className="row align-items-center">
        {/* Left Side - Text */}
        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
          <div className="mb-4 d-flex align-items-start">
            <img
              src={MissionIcon}
              alt="Mission Icon"
              className="me-3"
              style={{ width: "32px" }}
            />
            <div>
              <h4 className="fw-bold">{t.missionTitle}</h4>
              <p className="text-dark">{t.missionText}</p>
            </div>
          </div>

          <div className="d-flex align-items-start">
            <img
              src={VissionIcon}
              alt="Vision Icon"
              className="me-3"
              style={{ width: "32px" }}
            />
            <div>
              <h4 className="fw-bold">{t.visionTitle}</h4>
              <p className="text-dark">{t.visionText}</p>
            </div>
          </div>
        </div>

        {/* Right Side - Images */}
        <div className="col-12 col-lg-6">
          {/* Desktop View */}
          <div className="d-none d-lg-block position-relative" style={{ minHeight: "450px" }}>
            <img
              src={MissionImg1}
              alt="Img1"
              className="rounded position-absolute"
              style={{
                top: "20px",
                left: "13%",
                width: "35%",
                zIndex: 1,
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            />
            <img
              src={MissionImg2}
              alt="Img2"
              className="rounded position-absolute"
              style={{
                top: "20px",
                right: "0",
                width: "50%",
                zIndex: 2,
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            />
            <img
              src={MissionImg3}
              alt="Img3"
              className="rounded position-absolute"
              style={{
                bottom: "-32px",
                left: "38%",
                transform: "translateX(-50%)",
                width: "52%",
                zIndex: 3,
                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
              }}
            />
          </div>

          {/* Mobile and Tablet View */}
          <div className="d-block d-lg-none">
            <div className="px-2">
              <img
                src={MissionImg1}
                className="img-fluid rounded mb-3 w-100"
                alt="Mission 1"
                style={{ maxWidth: "100%", height: "auto" }}
              />
              <img
                src={MissionImg2}
                className="img-fluid rounded mb-3 w-100"
                alt="Mission 2"
                style={{ maxWidth: "100%", height: "auto" }}
              />
              <img
                src={MissionImg3}
                className="img-fluid rounded w-100"
                alt="Mission 3"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Who;